import React from 'react';
import { Plate } from '../../../basic/Plate/Plate';
import './PostText.scss';

interface IPostTextProps {
  text: string;
}

export function PostText({ text }: IPostTextProps) {
  return (
    <div className='PostText'>
      <Plate doNotCompensateBottom={true}>
        <p className='PostText__text'>
          <span className='PostText__quote'>"</span>
          { text }
          <span className='PostText__quote'>"</span>
        </p>
      </Plate>
    </div>
  );
}
